import React from 'react';
import Typography from '../atoms/Typography';
import Button from '../atoms/Button';
import ChevronRightIcon from '../atoms/ChevronRightIcon';
import { useNavigate } from "react-router-dom";
import { useDispatch } from 'react-redux';
import { setIsEdit , setId} from '../../redux/appDetails/reducer';
/**
 * Card footer molecule — "Updated on…" text + Configure button.
 */
export default function CardFooter({
  updatedOn,
  openLabel = 'Open',
  configureLabel = 'Configure',
  onOpen: _onOpen,
  // onConfigure,
  className = '',
  id: _id,
  title: _title,
}) {

  const navigate = useNavigate();

  // const onConfigure = () => {
  //   if (onConfigure) {
  //     onConfigure({ id: _id, title: _title });
  //   }
  // };
  const dispatch = useDispatch();

  const onOpenClick = () => {
    if (_id != null && _id !== '') {
      dispatch(setId(_id));
    }
    navigate(`/querymanagement`);
}

  return (
    <div className={`ca-system-card__footer ${className}`.trim()}>
      <Typography variant="small" as="span">
        {updatedOn ? `Updated on ${updatedOn}` : ''}
      </Typography>
      <div className="ca-system-card__footer-actions">
        <Button size="sm" onClick={onOpenClick}>
          {openLabel}
        </Button>
        <Button
          variant="outline"
          size="sm"
          onClick={()=>{
            dispatch(setIsEdit({ data: true }));
            dispatch(setId({ data: _id }));
            console.log("Configure button clicked");
            console.log("ID:", _id);
              navigate(`/settings/${_id ?? 'new'}?step=1`);
            // onConfigure?.({ id: _id, title: _title });
          }}
          endIcon={<ChevronRightIcon size={14} color="currentColor" />}
        >
          {configureLabel}
        </Button>
      </div>
    </div>
  );
}
